import NewFondationsApiModel from 'models/global/NewFondationsApiModel';

export default class EntityStatusHistoryModel extends NewFondationsApiModel {
	static get path(): string {
		return '/entity_status_histories/{?id}';
	}
}
